import axios from 'axios';
import store from '../store';  // 引入 Vuex store
import { addSM, getRaw } from './smUtil';// 引入加密和解密工具函数

import {Message, MessageBox} from 'element-ui';
axios.defaults.withCredentials = true
// 创建 Axios 实例
const axiosInstance = axios.create({
    timeout: 100000000,  // 请求超时时间
});
// 请求拦截器：加密请求数据
axiosInstance.interceptors.request.use(
    (config) => {
        const token = store.getters.getToken;
        const userid = store.getters.getUserId;// 获取 TOKEN
        // 1) 上传/下载 或显式跳过 → 不加密
        const isFormData = config.data instanceof FormData
        const wantsBlob   = config.responseType === 'arraybuffer'
        const skipByFlag  = !!config.skipEncrypt

        const shouldSkip = isFormData || wantsBlob || skipByFlag

        if(userid){
            config.data.userId = userid;
        }
        if (!shouldSkip) {
            // 如果请求中有数据（POST请求），先进行加密
            const requestData = config;
            addSM(requestData);  // 加密请求数据
            config = requestData;
        }

        if (token) {
            // 在请求头中添加 TOKEN
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器：解密响应数据
axiosInstance.interceptors.response.use(
    (response) => {
        if (response.data.sign) {
            const decodedData = getRaw(response);  // 解密返回的数据
            response = decodedData;
        }
        if (response.code === "CANTBENULL001") {
            Message.error('请求的内容为空，请检查输入!');}
        else if (response.code === "VOLUNTEER504") {
            MessageBox.alert(response.msg, '提示', {
                confirmButtonText: '确定',
                callback: () => {
                    store.dispatch('logout').then(() => {
                        location.reload();
                    });
                }
            });
        }else if (response.code === "500" ) {
            Message.error(response.msg);
        }else if (response.code === "VOLUNTEER503") {
            MessageBox.alert(response.msg, '提示', {
                confirmButtonText: '确定',
                callback: () => {
                    store.dispatch('logout').then(() => {
                        location.reload();
                    });
                }
            });
        }
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);
export default axiosInstance;  // 导出 Axios 实例

